<template>
    <div v-if="load == true" class="container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div style="width: 600px; margin: auto auto;">
            <v-card class="box">
                <v-card-title class="brand onBrand--text">
                    <span class="headline">Add Mobile Links</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded dense :items="usertype" v-model="selusertype"
                                    label="Select User Type" item-text="name" persistent-hint
                                    prepend-icon="mdi-clipboard-account" />
                            </v-col>
                        </v-row>
                        <v-row dense v-if="selusertype == 'Employee'">
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded dense :items="emp_type_list" v-model="selemptype"
                                    label="Select Employee Type" item-text="name" persistent-hint
                                    prepend-icon="mdi-clipboard-account" />
                            </v-col>
                        </v-row>
                        <v-row dense v-if="ajaxload == true">
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded :items="sm_links" v-model="selsm_link" return-object
                                    label="Select Link" chips dense small-chips item-text="sm_linkname" persistent-hint
                                    hint="Link name can be edited from the below list."
                                    prepend-icon="mdi-link-box-variant" />
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded v-model="link_sort" type="number" dense
                                    label="Sort Order" prepend-icon="mdi-format-list-numbered"
                                    :error="errorMsg.sortOrder ? true : false"
                                    :error-messages="errorMsg.sortOrder ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-row align="center" justify="center">
                                    <v-btn class="button" @click="pushlinktotenant()">Add</v-btn>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="12">
                                <div v-show="status.code">
                                    <v-alert outlined :type="status.code == 'SUCCESS' ? 'success' : 'warning'" prominent
                                        border="left" dismissible>{{ status.message }}</v-alert>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>
        <br />
        <v-simple-table class="elevation-1 mytable" v-if="tabledata.length > 0" cols="12">
            <template v-slot:default>
                <thead>
                    <tr>
                        <td colspan="2">
                            <v-autocomplete class="mr-2 pt-6" flat hide-details rounded dense outlined label="User Type"
                                multiple clearable :items="dataValueList('usertype')"
                                v-model="filters.usertype"></v-autocomplete>
                        </td>
                        <td colspan="2">
                            <v-autocomplete class="mr-2 pt-6" flat hide-details rounded dense outlined
                                label="Employee Type" multiple clearable :items="dataValueList('selemptype')"
                                v-model="filters.selemptype"></v-autocomplete>
                        </td>
                        <td colspan="4">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </td>
                    </tr>
                    <br />
                    <tr>
                        <th class="text-left">Link Name</th>
                        <th class="text-left">Display Name</th>
                        <th class="text-left">Sort Order</th>
                        <th class="text-left">User Type</th>
                        <th class="text-left">Employee Type</th>
                        <th class="text-left">Is Active</th>
                        <th class="text-left">Action</th>
                        <th class="text-left">Link Accessibility</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredItems" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.displayname }}</td>
                        <td>{{ item.sort_order }}</td>
                        <td>{{ item.usertype }}</td>
                        <td>{{ item.selemptype }}</td>
                        <td>
                            <span v-if="item.isactive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </td>
                        <td>
                            <v-avatar style size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" @click="editrolelinks(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </td>
                        <td>
                            <v-btn :loading="loader" class="button" small @click="getUser(item.usertype,item.id,item.selemptype)">Link
                                Accessibility Staus</v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
                <v-card-title class="toolbar">
                    <span class="headline">Edit User Role Links</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.name" label="Link Name"
                                    prepend-icon="mdi-link" clearable id="name" :error="errorMsg.name ? true : false"
                                    :error-messages="errorMsg.name ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.displayname" label="Display Name"
                                    clearable hint="Optional" prepend-icon="mdi-link-plus"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.sort_order" label="Sort Order"
                                    id="sortorder" type="number" prepend-icon="mdi-format-list-numbered"
                                    :error="errorMsg.sortOrder ? true : false"
                                    :error-messages="errorMsg.sortOrder ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" v-if="edititem.usertype == 'Employee'">
                                <v-autocomplete outlined rounded dense :items="emp_type_list"
                                    v-model="edititem.selemptype" label="Select Employee Type" item-text="name"
                                    persistent-hint prepend-icon="mdi-clipboard-account" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-checkbox v-model="edititem.isactive" label="isActive" color="success" hide-details />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="close">Cancel</v-btn>
                    <v-btn class="button" @click="saveeditrolelinks">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog fullscreen v-model="dailog_mob_app_filter" persistent>
            <v-card>
                <v-col cols="12" md="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Mobile Links Accessibility Status </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card class="box">
                        <v-row dense justify="center">
                            <v-col cols="12" md="4" sm="4">
                                <v-autocomplete outlined rounded :items="user_list" v-model="block_user"
                                    label="Select User" multiple dense item-value="id" item-text="username"
                                    persistent-hint hint="Select User" />
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                                <v-btn class="button" @click="block_link_access()">Block Access</v-btn>
                            </v-col>
                        </v-row>
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong> Link Blocked Users List </strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-data-table class="mytable elevation-1" v-if="mob_app_link_filter_list!=''" dense
                            :headers="headers" :items="mob_app_link_filter_list" @current-items="getFiltered">
                            <template v-slot:top class="pb-5">
                                <v-row dense justify="center" align="center">
                                    <tr class="t-row">
                                        <div>
                                            <th>
                                                <v-row>
                                                    <span v-for="header in headers" :key="header.text">
                                                        <span v-if="filters.hasOwnProperty(header.value)">
                                                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details
                                                                small rounded dense outlined color="#0F2027"
                                                                :label="header.text" multiple clearable
                                                                :items="columnValueList(header.value)"
                                                                v-model="filters[header.value]"></v-autocomplete>
                                                        </span>
                                                    </span>
                                                </v-row>
                                            </th>
                                        </div>
                                    </tr>
                                </v-row>
                            </template>
                            <template v-slot:item.unblock_user="{ item }">
                                <v-btn small @click="delete_link_access(item.maf_id,item.mal_id)"
                                    class="button">Delete</v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                    <center></center>
                    <center><v-btn class="button" @click="dailog_mob_app_filter=false">Cancel</v-btn></center>
                </v-col>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },
        data() {
            return {
                errorMsg: {
                    sortOrder: false,
                    name: false,
                },
                overlay: false,
                snackbar_msg: "",
                loader: false,
                color: "",
                snackbar: false,
                // extraBreadcrumbItems: [


                // // ],
                // breadcrumbClass: "breadcrumb-style2",
                search: "",
                dialog: false,
                load: false,
                ajaxload: false,
                emp_type_list: [],
                block_user: [],
                mobileAppLink_id: null,
                usertype: {
                    id: "",
                    name: "",
                },
                roles: {
                    //list
                    id: "",
                    name: "",
                },
                sel_role: {}, //instance of roles
                selusertype: "",
                selemptype: "",
                //
                sm_links: {
                    //will contain list; assigned from api
                    sm_linkid: "",
                    sm_linkname: "",
                },
                selsm_link: [], //will be instance of sm_links
                link_description: "",
                link_sort: 0,
                tabledata: {}, //to show all added roles links
                status: {},
                edititem: {},
                mob_app_link_filter_list: [],
                user_list: [],
                dailog_mob_app_filter: false,
                filterArr: [],
                filters: {
                    user: [],
                    usertype: [],
                    selemptype: [],
                },
                // { "entry_by": "cs1.wakad@wisdomworldschool.in", "user_id": 8, "mal_id": 22,
                // "user": "G18190017.wakad@wisdomworldschool.in", "maf_id": 1, "entry_date": "17/Jun/2024" },
                headers: [
                    { text: "Sr. No.", value: "count" },
                    { text: "Entry Date", value: "entry_date" },
                    { text: "Entry By", value: "entry_by" },
                    { text: "User", value: "user" },
                    { text: "Delete", value: "unblock_user" },
                ],
            };
        },
        mounted() {
            this.overlay = true;
            this.load = false;
            axios
                .post("/Admin/mobileAppLinksHome")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.usertype = res.data.usertype;
                        this.emp_type_list = res.data.emp_type_list;
                        this.modules = res.data.roletype;
                        this.load = true;
                        this.tabledata = res.data.mobilelink_list;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        watch: {
            selusertype() {
                this.getroleuserlist();
                this.status = {};
            },

            block_user(newVal, oldVal) {
                if (newVal.includes("ALL") && newVal.length === 1) {
                    const allIds = this.user_list.map(u => u.id);

                    if (JSON.stringify(newVal) !== JSON.stringify(allIds)) {
                        this.block_user = allIds;
                    }
                    return;
                }
                if (oldVal.includes("ALL") && !newVal.includes("ALL")) {
                    this.block_user = [];
                    return;
                }
            }
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.mob_app_link_filter_list.map((d) => d[val]);
            },
            async delete_link_access(maf_id, mal_id) {
                const data = { maf_id: maf_id, mal_id: mal_id }
                try {
                    const res = await axios.post("/Admin/delete_link_access", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Deleted Successfully...");
                        this.mob_app_link_filter_list = res.data.mob_app_link_filter_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.onerror(err);
                } finally {
                    this.block_user = [];
                }
            },
            async block_link_access() {
                const data = {
                    block_user: this.block_user,
                    mobileAppLink_id: this.mobileAppLink_id,
                };
                try {
                    const res = await axios.post("/Admin/block_link_access", data);
                    if (res.data.flag == "YES") {
                        this.mob_app_link_filter_list = res.data.mob_app_link_filter_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.onerror(err);
                } finally {
                    this.block_user = [];
                }
            },
            async getUser(type, mid, employeetype) {
                // alert("hi"+this.employeetype);
                this.user_list = [];  
                this.mobileAppLink_id = null;
                const data = {
                    type: type,
                    mid: mid,
                    employeetype: employeetype || null
                };
                try {
                    this.loader = true;
                    const res = await axios.post("/Admin/getUserList", data);
                    if (res.data.flag == "YES") {
                        this.mob_app_link_filter_list = res.data.mob_app_link_filter_list;
                        // this.user_list = res.data.user_list;
                        this.user_list = [{ id: 'ALL', username: 'All' }, ...res.data.user_list];
                        this.mobileAppLink_id = res.data.mobileAppLink;
                        this.dailog_mob_app_filter = true;
                        this.loader = false;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.loader = false;
                    }
                } catch (err) {
                    this.onerror(err);
                    this.loader = false;
                } finally {
                    this.loader = false;
                }
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            initializeErrorMsgFalse() {
                this.errorMsg.sortOrder = false;
                this.errorMsg.name = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            saveeditrolelinks() {
                if (this.isSaveEditValidated()) {
                    axios
                        .post("/Admin/editMobileAppLinksHome", this.edititem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.tabledata = res.data.mobilelink_list;
                                this.showSnackbar("#4caf50", "Mobile Link Updated Successfully..."); // show snackbar on success
                            } else {
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
                // this.close();
            },

            close() {
                this.initializeErrorMsgFalse();
                this.edititem = {};
                this.dialog = false;
            },
            editrolelinks(item) {
                this.edititem = Object.assign({}, item);
                this.dialog = true;
            },
            pushlinktotenant() {
                this.overlay = true;
                this.initializeErrorMsgFalse();
                const req_data = {
                    selusertype: this.selusertype,
                    sm_link: this.selsm_link,
                    selemptype: this.selemptype,
                    link_sort: this.link_sort,
                };
                if (this.link_sort >= 0 || this.link_sort < 0) {
                    axios
                        .post("/Admin/saveMobileAppLinksHome", req_data)
                        .then((res) => {
                            this.overlay = false;
                            if (res.data.flag == "YES") {
                                if (res.data.status.code == "SUCCESS") {
                                    this.status = res.data.status;
                                    this.selsm_link = [];
                                    this.link_description = "";
                                    this.link_sort = 0;

                                    this.getroleuserlist();
                                    this.showSnackbar("#4caf50", "Role Link Added Successfully..."); // show snackbar on success
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Link Already Added!!!"); // show snackbar on success
                                }
                                //   this.sel_role = { id: "", name: "" };
                            } else {
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                            this.overlay = false;
                        })
                        .finally((error) => {
                            this.overlay = false;
                            this.selemptype = null,
                                this.selusertype = null
                        });
                } else {
                    this.errorMsg.sortOrder = true;
                }
            },

            getroleuserlist() {
                if (this.selusertype != "") {
                    const req_data = {
                        usertype: this.selusertype,
                    };
                    this.overlay = true;
                    axios
                        .post("/Admin/getRoleUserListForMobile", req_data)
                        .then((res) => {
                            this.overlay = false;
                            if (res.data.flag == "YES") {
                                this.ajaxload = true;
                                this.sm_links = res.data.sm_links;
                                this.tabledata = res.data.mobilelink_list;
                            } else {
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                        })
                        .catch((error) => {
                            this.overlay = false;
                            window.console.log(error);
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                }
            },
            isSaveEditValidated() {
                //alert("sort_order>>"+this.edititem.sort_order)
                var name = document.getElementById("name").value;
                var sortorder = document.getElementById("sortorder").value;
                // alert(name+"  "+sortorder);
                if (!name.length == 0 && !sortorder.length == 0) {
                    return true;
                } else {
                    if (name.length == 0) {
                        this.errorMsg.name = true;
                    }
                    if (sortorder.length == 0) {
                        this.errorMsg.sortOrder = true;
                    }
                    return false;
                }
            }, // end of isSaveEditValidated()
            dataValueList(column) {
                return [...new Set(this.tabledata.map(item => item[column]))];
            }, // end of dataValueList()
        }, // end of method:{}

        computed: {
            bookList1() {
                return this.mob_app_link_filter_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
            // tablefilterdata() {
            //     return this.tabledata.filter((tbdata) => {
            //         return (
            //             tbdata.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            //             tbdata.displayname.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            //             //tbdata.sort_order.match(this.search) ||
            //             tbdata.usertype.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            //         );
            //         //tbdata.isactive.match(this.search)
            //     });
            // },
            filteredItems() {
                return this.tabledata.filter(item => {
                    const matchesSearch = this.search
                        ? item.name.toLowerCase().includes(this.search.toLowerCase()) ||
                        item.displayname.toLowerCase().includes(this.search.toLowerCase()) ||
                        item.sort_order.toString().includes(this.search) ||
                        item.usertype.toLowerCase().includes(this.search.toLowerCase()) ||
                        item.selemptype.toLowerCase().includes(this.search.toLowerCase())
                        : true;

                    const matchesUsertype = this.filters.usertype.length
                        ? this.filters.usertype.includes(item.usertype)
                        : true;

                    const matchesSelemptype = this.filters.selemptype.length
                        ? this.filters.selemptype.includes(item.selemptype)
                        : true;

                    return matchesSearch && matchesUsertype && matchesSelemptype;
                });
            }, // end of filteredItems()
        }, // end of computed
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>